import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="premium-shell flex min-h-screen items-center justify-center p-6">
      <div className="premium-panel w-full max-w-xl rounded-[2rem] p-8 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-primary/25 bg-primary/10 text-primary">
          <SearchX className="h-6 w-6" />
        </div>
        <p className="mt-6 font-mono text-xs uppercase tracking-[0.24em] text-muted-foreground">404</p>
        <h1 className="mt-3 text-4xl font-semibold tracking-[-0.06em]">Page not found</h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-muted-foreground">
          The page you requested is not part of this Workshop route map.
        </p>
        <Button asChild variant="premium" className="mt-7">
          <a href="/">
            <ArrowLeft className="h-4 w-4" />
            Return home
          </a>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
